// FR <-> EN route mapping for the language switcher.
// French is the default/primary version. English pages live only under /en/.
// Only list pairs that are TRUE equivalents (no thin duplicates).

export const FR_TO_EN = {
  '/': '/en/',
  '/services': '/en/garden-maintenance-vendee',
  '/entretien-residence-secondaire': '/en/holiday-home-garden-care-vendee',
  '/credit-impot-jardinage': '/en/sap-garden-tax-credit-france',
  '/contact': '/en/contact',
};

export const EN_TO_FR = {
  '/en/': '/',
  '/en/garden-maintenance-vendee': '/services',
  '/en/holiday-home-garden-care-vendee': '/entretien-residence-secondaire',
  '/en/sap-garden-tax-credit-france': '/credit-impot-jardinage',
  '/en/contact': '/contact',
  '/en/areas': '/',
  // No good French equivalent -> falls back to the French homepage:
  '/en/campsite-garden-maintenance-vendee': '/',
  '/en/garden-tidy-up-coex': '/',
  '/en/lawn-mowing-coex': '/',
  '/en/hedge-cutting-coex': '/',
  '/en/pressure-washing-coex': '/',
  '/en/weeding-garden-clearance-coex': '/',
  '/en/areas/coex': '/',
  '/en/areas/landevieille-lac-du-jaunay': '/',
  '/en/areas/la-chapelle-hermier': '/',
  '/en/areas/saint-julien-des-landes': '/',
  '/en/areas/apremont': '/',
};

export const EN_PATHS = [
  '/en/',
  '/en/garden-maintenance-vendee',
  '/en/holiday-home-garden-care-vendee',
  '/en/campsite-garden-maintenance-vendee',
  '/en/garden-tidy-up-coex',
  '/en/lawn-mowing-coex',
  '/en/hedge-cutting-coex',
  '/en/pressure-washing-coex',
  '/en/weeding-garden-clearance-coex',
  '/en/sap-garden-tax-credit-france',
  '/en/contact',
  '/en/areas',
  '/en/areas/coex',
  '/en/areas/landevieille-lac-du-jaunay',
  '/en/areas/la-chapelle-hermier',
  '/en/areas/saint-julien-des-landes',
  '/en/areas/apremont',
];

const norm = (p) => {
  let s = (p || '/').toLowerCase();
  if (s.length > 1) s = s.replace(/\/+$/, '');
  return s || '/';
};

export const isEnglishPath = (pathname) => {
  const p = norm(pathname);
  return p === '/en' || p.startsWith('/en/');
};

// Returns the URL to switch to the OTHER language from the current pathname.
export const getSwitchTarget = (pathname) => {
  const p = norm(pathname);
  if (isEnglishPath(pathname)) {
    const key = p === '/en' ? '/en/' : p;
    return EN_TO_FR[key] || '/';
  }
  return FR_TO_EN[p] || '/en/';
};
